import { getSignalRConnectionId } from 'utils/streaming/signalr/connection';

import type { IHttpConfig } from '../../httpClient.model';

export default (config: IHttpConfig): IHttpConfig => {
  return {
    ...config,
    headers: {
      ...config.headers,
      'signalr-connection-id': getSignalRConnectionId(),
    },
  };
};
